import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import Alert from '../Alert/Alert';
import { sendTrackingInfo } from '../sendTrackingInfo';
import { selectColor } from '../../core';
import { getColor } from '../../core/themev3';
// import { termsAndConditionsBySite } from '../../helpers';

const ReportsModal = ({
  onClose = () => {},
  device,
  isReserved,
  postingReports,
  redirectToEdit = () => {},
  isIntegrator,
  hasReportsUnchecked = false,
  fetchReports = () => {},
  checkReport = () => {},
  savePostingTag = () => {},
  isAssistant
}) => {
  const { t } = useTranslation();
  // const termsAndConditionsUrl = termsAndConditionsBySite();
  // const redirectToTermsAndConditions = () => {
  //   window.location.href = termsAndConditionsUrl;
  // };
  const totalReport = postingReports && postingReports.totalReport;
  const reports = postingReports && postingReports.reports;
  const showReservationButton = reports && reports.some(r => r.reportTypeId === '1' || r.reportTypeId === '10');

  useEffect(() => {
    if (hasReportsUnchecked) {
      checkReport();
    }
    return () => {
      if (hasReportsUnchecked) {
        fetchReports();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const statusPanel = Cookies.get('statusPanel');
    if (!statusPanel && isIntegrator) {
      Cookies.set('statusPanel', true, {
        expires: 1
      });
    }
  }, [isIntegrator]);

  return (
    <Container device={device} isIntegrator={isIntegrator}>
      <TopArea>
        <Title data-panel='panel-modal-report-title'>
          {t('panel.avisos.report.message')} {<b>{totalReport}</b>}{' '}
          {t(`panel.avisos.report.message.end${totalReport > 1 ? '.plural' : ''}`)}
        </Title>
        <InfoArea device={device}>
          <Subtitle data-panel='panel-modal-report-subtitle'>{t('panel.avisos.report.modal.motives')}</Subtitle>
          <MotivesArea
            data-panel='panel-modal-report-motiveList'
            isIntegrator={isIntegrator}
            showReservationButton={showReservationButton && !isReserved}
          >
            {reports &&
              reports.map(r => (
                <ListItems
                  data-panel={`panel-modal-report-motiveList-reportId-${r.reportTypeId}`}
                  className={r.unChecked ? 'unchecked' : ''}
                  key={`report-${r.reportTypeId}`}
                >
                  {r.reportName}
                  <ul>
                    {r.message.map((msg, i) => (
                      <li className='internal-list' key={`${msg}-${1}`} data-panel={`panel-modal-reportlist-${i}`}>
                        {`"${msg}"`}
                      </li>
                    ))}
                  </ul>
                </ListItems>
              ))}
          </MotivesArea>
        </InfoArea>
      </TopArea>
      <LowerArea showReservationButton={showReservationButton && !isReserved}>
        <ReminderArea data-panel='panel-modal-report-text'>{t('panel.avisos.report.modal.message')}</ReminderArea>
        {isIntegrator && (
          <AlertContainer>
            <Alert message={t('panel.avisos.publish.modal.alert.integrador')} />
          </AlertContainer>
        )}
        {showReservationButton && !isReserved && !isAssistant && (
          <ReserveCTA
            data-panel='panel-modal-report-cta-reservar'
            onClick={() => {
              sendTrackingInfo('Panel', 'Mis avisos', `Denuncias-Marcar Reservado`);
              savePostingTag();
              onClose();
            }}
            showReservationButton={showReservationButton && !isReserved}
          >
            {t('panel.avisos.report.modal.cta.2')}
          </ReserveCTA>
        )}
        {!isAssistant && (
          <CTA
            data-panel='panel-modal-report-cta-editar'
            onClick={() => {
              sendTrackingInfo('Panel', 'Mis avisos', `Denuncias-Editar Aviso`);
              redirectToEdit();
              onClose();
            }}
            showReservationButton={showReservationButton && !isReserved}
          >
            {t('panel.avisos.report.modal.cta.3')}
          </CTA>
        )}
        {/* <TermsAndConditions
          data-panel='panel-modal-report-termsAndConditions'
          onClick={() => {
            sendTrackingInfo('Panel', 'Mis avisos', `Denuncias-Ver políticas`);
            redirectToTermsAndConditions();
          }}
        >
          {t('panel.avisos.report.modal.cta.1')}
        </TermsAndConditions> */}
      </LowerArea>
    </Container>
  );
};

const Container = styled.div`
  padding: 28px 28px 8px;
  box-sizing: border-box;
  height: fit-content;
  ${({ device }) =>
    device !== 'mobile' &&
    css`
      height: ${({ isIntegrator }) => (isIntegrator ? 600 : 532)}px;
      padding: 30px 45px 20px 45px;
    `};
  max-width: ${({ device }) => device !== 'mobile' && '443px'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const TopArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Title = styled.div`
  font-family: Hind;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
  white-space: normal;
  margin-bottom: 8px;
  padding-top: 10px;
  text-align: center;
`;

const InfoArea = styled.div`
  width: 100%;
  padding: ${({ device }) => device === 'mobile' && '0 16px'};
  white-space: pre-wrap;
`;

const Subtitle = styled.div`
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0em;
  color: ${selectColor('grayDark')};
  margin-bottom: 5px;
  width: 100%;
`;

const MotivesArea = styled.ul`
  font-size: 14px;
  font-weight: 600;
  max-height: ${({ showReservationButton }) => (showReservationButton ? 180 : 235)}px;
  ${({ isIntegrator }) =>
    isIntegrator &&
    css`
      max-height: ${({ showReservationButton }) => (showReservationButton ? 160 : 216)}px;
    `};
  list-style-type: disc;
  padding-left: 25px;
  padding-right: 4px;
  margin-top: 10px;
  overflow: auto;
  ::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  ::-webkit-scrollbar:vertical {
    width: 5px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 20px;
    border: 8px solid ${selectColor('grayMediumLight')};
  }
  .internal-list {
    font-weight: 400;
  }
`;

const ListItems = styled.li`
  width: 100%;
  font-size: 16px;
  .unchecked {
    font-weight: 600;
  }
`;
const ReminderArea = styled.p`
  width: 100%;
  white-space: pre-wrap;
  font-size: 16px;
  border-top: 1px solid ${selectColor('grayMedium')};
  padding-top: 10px;
  margin-bottom: 10px;
`;
const LowerArea = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

const CTA = styled.button`
  height: 40px;
  width: 100%;
  border-radius: 8px;
  color: white;
  background-color: ${getColor('primary')};
  padding: 0 12px;
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: center;
  cursor: pointer;
  white-space: pre-wrap;
  :hover {
    background-color: ${({ showReservationButton }) => !showReservationButton && getColor('secondary')};
  }
  ${({ showReservationButton }) =>
    showReservationButton &&
    css`
      border: 1px solid ${getColor('primary')};
      color: black;
      background-color: white;
      margin-top: 8px;
    `}
`;

const ReserveCTA = styled(CTA)`
  ${({ showReservationButton }) =>
    showReservationButton &&
    css`
      margin-bottom: 8px;
      color: white;
      background-color: ${getColor('primary')};
    `}
`;

const TermsAndConditions = styled.button`
  margin-top: 14px;
  width: 100%;
  border-radius: 12px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: center;
  cursor: pointer;
`;

const AlertContainer = styled.div`
  margin-bottom: 20px;
  font-size: 14px;
`;

export default ReportsModal;
